import React from 'react'
import 'swiper/dist/css/swiper.min.css'
import ZoomableImage from '../../../../../basic/ZoomableImage'
import * as media from '../../../../../media'
import styled from 'styled-components'

const BiggerThan1000Check = styled.div`
  ${media.smallerThan(600)`display:none;`}
`
const LessThan1000Check = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  ${media.biggerThan(601)`display:none;`}
  `

function One({list}) {
  return (
    <div>
      <BiggerThan1000Check>
        <ZoomableImage
          src={list[0]}
          style={{ maxHeight: '100%', maxWidth: '100%', padding: 20}}

          padding='25px'
          containerStyle={{
            paddingTop: 25,
            paddingBottom: 25,
            background: 'rgb(235,235,235)',
            height: 385,
            width: 400,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
          }}
        />
      </BiggerThan1000Check>
      <LessThan1000Check>
        <ZoomableImage
          src={list[0]}
          style={{ maxHeight: '100%', maxWidth: '100%', padding: 20}}
          padding='25px'
          containerStyle={{
            paddingTop: 25,
            paddingBottom: 25,
            background: 'rgb(235,235,235)',
            height: 320,
            width: 320,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
          }}
        />
      </LessThan1000Check>
    </div>
  )
}

export default One



// WEBPACK FOOTER //
// ./src/finwhale/common/item/image-list/one/index.js